import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import "./hamburger.scss";

const Hamburger = ({ isActive, className, ...props }) => {
  const classes = classNames(
    "hamburger",
    {
      "hamburger--is-active": isActive,
    },
    className
  );
  return (
    <div className={classes} {...props}>
      <div className="hamburger__stroke" />
      <div className="hamburger__stroke" />
      <div className="hamburger__stroke" />
    </div>
  );
};

Hamburger.propTypes = {
  isActive: PropTypes.bool,
  className: PropTypes.string,
};

export default Hamburger;
